export const offsetsDetailsList = [
    {
        name: 'fingerprint',
        type: 'text',
    },
    {
        name: 'createdAt',
        type: 'date',
    },
    {
        name: 'purchasedAt',
        type: 'completedDate',
    },
    {
        name: 'status',
        type: 'status',
    },
    {
        name: 'estimatedCarbon',
        type: 'dataCarbon',
    },
    {
        name: 'carbonOffsetByThirdParty',
        type: 'dataCarbon',
    },
    {
        name: 'estimatedPrice',
        type: 'dataPrice',
    },
];
